import { MenuButtonTrigger } from '@amzn/storm-ui';
import * as React from 'react';
import { useAccountDropdownBundle } from '../../../../providers/PantherLocalizationProvider';

type IA2AccountDropdownFilterButtonProps = {
  onClick: () => void;
  filteredAccountTypeCount: number;
};

export const IA2AccountDropdownFilterButton: React.FC<
  IA2AccountDropdownFilterButtonProps
> = ({ onClick, filteredAccountTypeCount }) => {
  const bundle = useAccountDropdownBundle();
  return (
    <MenuButtonTrigger onClick={onClick} transparent>
      {bundle.formatMessage('account-dropdown-filter-label', {
        numFilter: filteredAccountTypeCount,
      })}
    </MenuButtonTrigger>
  );
};
